import * as React from 'react';
import { TermsOfConsentContext } from '../TermsOfConsentContext';
import { createTermsOfConsentStore } from '../createTermsOfConsentStore';

export function WithTermsOfConsent<TProps extends object>(Component: React.FC<TProps>): React.FC<TProps> {
    const MemoizedComponent = React.memo(Component);

    const ComponentWithTermsOfConsent: React.FC<TProps> = props => {
        const [termsOfConsentStore] = React.useState(() => createTermsOfConsentStore());

        return (
            <TermsOfConsentContext.Provider value={{ termsOfConsentStore }}>
                <MemoizedComponent {...props} />
            </TermsOfConsentContext.Provider>
        );
    };

    ComponentWithTermsOfConsent.displayName = `${Component.displayName || 'Component'}WithTermsOfConsent`;

    return ComponentWithTermsOfConsent;
}
